/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class FileRecord {
    userId;
    conversation;
    messageUid;
    name;
    url;
    size;
    downloadCount;
    timestamp;
}
